import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Spinner, Accordion, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { getProtocols, completeTask } from '../../actions/other/protocolsActions'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { getTemplates } from '../../actions/other/templatesActions'

export default function Dashboard() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()
    const { protocols, loading } = useSelector(state => state.protocols)
    const { templates } = useSelector(state => state.templates)

    const [tasksByDate, setTasksByDate] = useState({})
    const [selectedDate, setSelectedDate] = useState(new Date())

    useEffect(() => {
        if (clientauth) {
            dispatch(getProtocols())
            dispatch(getTemplates())
        }
    }, [dispatch, clientauth])

    useEffect(() => {
        if (protocols && protocols.length > 0) {
            const groupedTasks = {}

            protocols.forEach(protocol => {
                const start = new Date(protocol.startDate)

                protocol.tasks?.forEach((task, index) => {
                    if(task.assignedTo === 'breeder') {
                        const taskDate = new Date(start)
                        taskDate.setDate(taskDate.getDate() + task.day)
                        const key = taskDate.toDateString()

                        if (!groupedTasks[key]) groupedTasks[key] = []

                        groupedTasks[key].push({
                            ...task,
                            step: task.step,
                            protocolId: protocol._id,
                            taskIndex: index,
                            templateName: protocol?.template?.name,
                            animals: protocol.animals || [],
                            lots: protocol.lots || []
                        })
                    }
                })
            })

            setTasksByDate(groupedTasks)
        }
    }, [protocols])

    // Contenido de cada celda del calendario
    const tileContent = ({ date, view }) => {
        if (view === 'month') {
            const key = date.toDateString()
            if (tasksByDate[key]) {
                return (
                    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                        {tasksByDate[key].map((task, i) => (
                            <li key={i} style={{ fontSize: '0.7rem' }}>• {task.step}</li>
                        ))}
                    </ul>
                )
            }
        }
        return null
    }

    const handleCheck = (protocolId, taskIndex) => {
        dispatch(completeTask(protocolId, taskIndex))
    }

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('breeder.calendar.calendar')}</h1>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs={12}>
                    {loading ? (
                        <Spinner animation="border" />
                    ) : (
                        <Calendar
                            tileContent={tileContent}
                            onClickDay={(date) => setSelectedDate(date)}
                        />
                    )}
                </Col>
            </Row>

            {selectedDate && (
                <Row className="mt-4">
                    <Col xs={12}>
                        <h5>
                            {t('breeder.calendar.tasksFor')} {selectedDate.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                        </h5>
                        <Accordion defaultActiveKey="0">
                            {(tasksByDate[selectedDate.toDateString()] || []).map((task, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header>{task.templateName} - {task.step}</Accordion.Header>
                                    <Accordion.Body>
                                        {task.lots.length > 0 && (
                                            <div>
                                                <strong>Lotes:</strong>
                                                <ul>
                                                    {task?.lots?.map((lot, i) => (
                                                        <li key={i}>{lot.identifier}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        {task.animals.length > 0 && (
                                            <div>
                                                <strong>Animales:</strong>
                                                <ul>
                                                    {task?.animals?.map((animal, i) => (
                                                        <li key={i}>{animal.crotal}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        <Form.Check
                                            type="checkbox"
                                            label={t('breeder.calendar.taskCompleted')}
                                            checked={task.completed}
                                            disabled={task.completed}
                                            onChange={() =>
                                                handleCheck(task.protocolId, task.taskIndex)
                                            }
                                        />
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            )}
        </Container>
    )
}